<template>
  <div class="select_dialog_embed" :style="{top: scrollHeight + 'px', left: scrollLeft + 'px'}">
    <div class="goods_num_inventory_enquiry_embed_msg">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息 --- 货品详情 -->
        <div v-if="showType === 'goodDetail'" class="select_dialog_embed_box_content">
          <!--货品详情-->
          <div class="select_dialog_embed_box_handle">
            <!--货品详情上部分——包含图片-->
            <div class="good_detail_top">
              <div class="good_detail_top_left clear">
                <table>
                  <tr>
                    <td class="text_right fwb">货号：</td>
                    <td colspan="3" class="text_left">{{goodDetail.GoodsId}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">款号：</td>
                    <td colspan="3" class="text_left">{{goodDetail.GoodsName}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">零售价：</td>
                    <td class="text_left">{{goodDetail.MarketPrice}}</td>
                    <td class="text_right fwb">性别：</td>
                    <td class="text_left">{{goodDetail.Gender | gender}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">码段：</td>
                    <td class="text_left">{{goodDetail.SGName}}</td>
                    <td class="text_right fwb">分类：</td>
                    <td class="text_left">{{goodDetail.ClassName}}</td>
                  </tr>
                  <tr>
                    <td class="text_right fwb">创建时间：</td>
                    <td class="text_left">{{goodDetail.CreateTime | time}}</td>
                    <td class="text_right fwb">上市季节：</td>
                    <td class="text_left">{{goodDetail.MarketSeasoin}}</td>
                  </tr>
                </table>
              </div>
              <div class="good_detail_top_right clear">
                <img :src="goodDetail.MainImgUrl" height="200" width="200"/>
                <a v-if="isShowZip" title="下载货品图片压缩包" @click="downZip()">下载货品图片压缩包</a>
              </div>
            </div>
            <!--货品详情下部分——表格-->
            <div class="good_detail_bottom">
              <!--表格固定头部-->
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <thead>
                <tr>
                  <th>颜色</th>
                  <th>尺码（[美国码][欧洲码]）</th>
                  <th>商家编码</th>
                  <th>条码</th>
                  <th>重量（g）</th>
                </tr>
                </thead>
              </table>
              <!--表格滚动内容-->
              <table class="table">
                <colgroup>
                  <col style="width: 100%">
                </colgroup>
                <tbody v-if="goodDetail.Skus">
                <tr v-for="(item, index) in goodDetail.Skus" :key="index">
                  <td>{{item.ColorAlias}}</td>
                  <td>{{item.Size}}([{{item.AmericanSize}}][{{item.EuropeSize}}])</td>
                  <td>{{item.BusinessCode}}</td>
                  <td>{{item.BarCode}}</td>
                  <td>{{item.GoodsSkuWeight}}</td>
                </tr>
                </tbody>
                <tbody v-if="!goodDetail.Skus">
                <tr>
                  <td colspan="5">暂时没有相关内容</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!--弹出框信息 --- 渠道详情 -->
        <div v-if="showType === 'channelDetail'" class="select_dialog_embed_box_content">
          <!--顶部信息-->
          <div class="channel_detail_top">
            <div class="channel_detail_top_left">
              <div><label>供应商编号：</label><span>{{channelDetail.SupplierCode}}</span></div>
              <!--<div><label>渠道编号：</label><span>{{channelDetail.SupplierCode}}_{{channelDetail.StoreroomCode}}</span></div>-->
              <div><label>渠道编号：</label><span>{{channelDetail.StoreroomCode}}</span></div>
              <div><label>发货地址：</label><span>{{channelDetail.SendProvinceName}}{{channelDetail.SendCityName}}{{channelDetail.SendAreaName}}</span></div>
              <div><label>联系电话：</label><span>{{channelDetail.Tel}}</span></div>
              <!--<div><label>QQ号：</label><span>{{channelDetail.QQ}}</span></div>-->
              <div><label>截单时间：</label><span>{{channelDetail.StopJiaoDanString}}</span></div>
              <div v-if="channelDetail.PromiseSendRate"><label>承诺配货率：</label><span>{{channelDetail.PromiseSendRate}}%</span></div>
              <div v-if="!channelDetail.PromiseSendRate"><label>承诺配货率：</label><span></span></div>
              <!--<div><label>免费退货比例：</label><span>{{channelDetail.FreeMaxRefundRate}}%</span></div>-->
              <div><label>？允许售后：</label><span>{{channelDetail.IsReOrder | aftersale}}</span></div>
              <div><label>超比例退货费用：</label><span>￥{{channelDetail.RefundFee}}</span></div>
              <!--<div><label>库存更新时间：</label><span>{{channelDetail.StockUpdateTime}}</span></div>-->
            </div>
            <div class="channel_detail_top_right">
              <div><label>供应商名称：</label><span>{{channelDetail.SupplierName}}</span></div>
              <div><label>渠道名称：</label><span>{{channelDetail.StoreroomName}}</span></div>
              <div><label>？渠道包邮：</label><span>{{channelDetail.IsFreeShip | isfreeship}}</span></div>
              <!--<div><label>微信号：</label><span>{{channelDetail.Wetchart}}</span></div>-->
              <div><label>邮箱：</label><span>{{channelDetail.Email}}</span></div>
              <div><label>渠道类型：</label><span>{{channelDetail.StoreroomType | channeltype}}</span></div>
              <div v-if="channelDetail.RealSendRate"><label>实际配货率：</label><span>{{channelDetail.RealSendRate}}%</span></div>
              <div v-if="!channelDetail.RealSendRate"><label>实际配货率：</label><span></span></div>
              <!--<div><label>超比例退货费用：</label><span>￥{{channelDetail.RefundRate}}</span></div>-->
              <div><label>免费退货比例：</label><span>{{channelDetail.FreeRefundRate}}%</span></div>
              <div><label>发货日期：</label><span>{{channelDetail.SendWeekday}}</span></div>
            </div>
            <!--<div><label>发货日期：</label><span>{{channelDetail.week}}</span></div>-->
          </div>
          <div class="mb10"><label>库存更新时间：</label><span>{{channelDetail.StockUpdateTime | time}}</span></div>
          <!--底部信息-->
          <div class="channel_detail_bottom">
            <div><label>不发货日期：</label><textarea title="不发货日期" v-model="channelDetail.NoSendDay" disabled></textarea></div>
            <div><label>退货说明：</label><textarea title="退货说明" v-model="channelDetail.RefundRemark" disabled></textarea></div>
            <div><label>退货地址：</label><textarea title="退货地址" v-model="channelDetail.RefundAddress" disabled></textarea></div>
            <div><label>备注：</label><textarea title="备注" v-model="channelDetail.Remark" disabled></textarea></div>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button class="btn_cancel" @click="cancelBtn(showType)">关闭</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"@closebtn="closeMsgDialog"></msg-dialog>
    </div>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';
    export default {
        name: 'goods-num-inventory-enquiry-embed-msg',
      /**
       *  title：  头部名
       *  showType: goodDetail=货品详情信息
       *  goodMsg: 货品信息
       *  scrollLeft 滚动的宽度
       *  scrollHeight: 滚动的高度
       * */
      props: ['title', 'showType', 'goodMsg', 'scrollLeft', 'scrollHeight'],
      components: {MsgDialog},
      data() {
        return {
          goodDetail: '', // 货品详情
          channelDetail: '', // 渠道详情
          isShowZip: false, // 是否显示下载压缩包按钮
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '', // 信息框内容
          time: 3, // 倒计时时间
          timer: null // 计时器
        }
      },
      methods: {
        // 点击货号查看货品详情
        getGoodsInfoById() {
          this.$axios.post(this.Global.getGoodsInfoById(this.goodMsg.GoodsId)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.goodDetail = res.data.resData;
              if (this.goodDetail.MainImgUrl === '') {
                this.goodDetail.MainImgUrl = null;
              }
              this.isShowZip = this.goodDetail.ZipImgUrl !== '';
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 查看渠道详情
        getStoreroomModelById() {
          this.$axios.get(this.Global.getStoreroomModelById(this.goodMsg.channelId), null).then((res) => {
            // console.log(res);
            this.channelDetail = res.data.resData;
          });
        },

        // 下载商品图片压缩包
        downZip() {
          this.$axios.get(this.Global.downZip(this.goodMsg.GoodsId)).then((res) => {
            // window.open(res.data, '_blank');
            if (!res.data.errorMsg.length) {
              window.open(res.data.resData, '_blank');
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 取消按钮
        cancelBtn(showType) {
          this.$emit('cancelbtn', {isShow: false, showType: showType});
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
        }
      },
      created() {
        if (this.showType === 'goodDetail') {
          this.getGoodsInfoById();
        } else if (this.showType === 'channelDetail') {
          this.getStoreroomModelById();
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .goods_num_inventory_enquiry {
    overflow: hidden;
  }

  .select_dialog_embed {
    .goods_num_inventory_enquiry_embed_msg {
      width: 90%;
      min-width: 580px;
      max-height: 100%;

      .select_dialog_embed_box {
        width: 100%;

        /* 货品详情 */
        .select_dialog_embed_box_handle {
          width: 100%;
          margin-top: 10px;

          .good_detail_top {
            width: 100%;
            height: 200px;

            .good_detail_top_left, .good_detail_top_right {
              display: inline-block;
              float: left;
              height: 100%;
            }

            .good_detail_top_left {
              /*background-color: #13ce66;*/
              width: 55%;

              table {
                width: 73%;
                margin-left: 30px;
                border: none;

                tr {
                  border: none;
                }

                th, td {
                  border: none;
                  padding: 10px 0;
                }
              }
            }

            .good_detail_top_right {
              width: 45%;

              a {
                color: $calink;
                margin-left: 30px;
                position: relative;
                bottom: 15px;

                &:hover {
                  cursor: pointer;
                }
              }
            }
          }

          .good_detail_bottom {
            width: 98%;
            margin: 10px auto;
            text-align: center;

            table {
              &:nth-child(2) {
                border-bottom: 1px solid #eee;
              }

              thead, tbody tr {
                display: table;
                width: 100%;
                table-layout: fixed;
              }

              tbody {
                display: block;
                width: 100%;
                height: 250px;
                overflow-y: auto;
              }
            }
          }
        }

        /* 渠道详情 */
        .select_dialog_embed_box_content {
         /* width: 90%;
          padding: 0 5%;*/

          label {
            font-weight: bolder;
            display: inline-block;
            width: 120px;
            text-align: right;
          }

          .channel_detail_top {
            width: 100%;
            height: 234px;
            margin-bottom: 10px;

            .channel_detail_top_left {
              width: 48%;
            }

            .channel_detail_top_right {
              width: 52%;
            }

            .channel_detail_top_left, .channel_detail_top_right {
              display: inline-block;
              float: left;
              margin-bottom: 5px;

              div {
                margin-top: 10px;
              }
            }
          }

          .channel_detail_bottom {
            div {
              margin-bottom: 5px;
            }

            label {
              height: 65px;
              line-height: 65px;
              float: left;
            }

            textarea {
              width: 75%;
              height: 45px;
              padding: 10px;
              resize: none;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/goods-num-inventory-enquiry-embed-msg.vue